import type { ReactNode } from 'react';

/**
 * The nothing-here state.
 *
 * Sized down on short viewports rather than hidden: on a phone in landscape the
 * illustration would otherwise push the message off screen, and the message is the
 * part that matters.
 */
export function EmptyState({
  title,
  description,
  size = 'lg',
  children,
}: {
  title: string;
  description?: ReactNode;
  size?: 'sm' | 'lg';
  children?: ReactNode;
}) {
  const image = size === 'lg' ? 168 : 96;

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-1 p-6 text-center">
      <img
        src="/assets/empty.png"
        alt=""
        width={image}
        height={image}
        // Decorative, and the biggest thing on an otherwise empty screen — so it is
        // pulled back rather than made the loudest element on the page.
        className="mb-2 max-w-[45vw] opacity-90"
        style={{ width: image, height: image }}
      />

      <p className={size === 'lg' ? 'text-sm font-medium' : 'text-xs font-medium'}>{title}</p>

      {description && (
        <p className="max-w-xs text-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>
          {description}
        </p>
      )}

      {children}
    </div>
  );
}
